// extracted by mini-css-extract-plugin
export default {"modalBtn":"AskQuestionModal_modalBtn__ct9S6","greetingText":"AskQuestionModal_greetingText__pkyYA"};